/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_DescInputs */

const en_support_desc = /** @type {(inputs: Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions, bugs or billing — write to us and we reply within a working day.`)
};

const id_support_desc = /** @type {(inputs: Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan, bug, atau tagihan — tulis ke kami, dibalas dalam satu hari kerja.`)
};

/**
* | output |
* | --- |
* | "Questions, bugs or billing — write to us and we reply within a working day." |
*
* @param {Support_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_desc = /** @type {((inputs?: Support_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_desc(inputs)
	return en_support_desc(inputs)
});